import React, { useState } from "react";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
// import video from "../../../Assets/video/photo-booth-360-video.webm";
import video from "../../../Assets/video/aaphotobooth360video.mp4";
import thumbnail from "../../../Assets/img/aa-photobooth-360-booth2.jpg";
import ReactPlayer from "react-player";
import {Collapse} from "antd";
import ExperienceColData from "../Data/ExperienceColData"

const Experience = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <section className="aa-ph-container py-[70px] sm:py-[100px] px-4 sm:px-2 lg:px-0 mt-[200px]">
      <h2 className="text-center font-medium text-[32px] sm:text-[60px] md:text-[90px] lg:text-[150px] leading-[38px] sm:leading-[70px] md:leading-[100px] lg:leading-[160px]">
        OUR EVENTS
      </h2>
      <div
        onClick={() => setIsPlaying(!isPlaying)}
        className="bg-video w-full lg:w-[1024px] mx-auto !h-[300px] sm:h-full sm:min-h-[500px] cursor-pointer"
      >
        <ReactPlayer
          url={video}
          light={thumbnail}
          loop={true}
          playing={isPlaying}
          width="inherit"
          className="h-full h-[280px] sm:min-h-[500px] lg:w-[1024px]"
          controls={false}
          playIcon={false}
        />
      </div>
      <div className="mx-auto w-full sm:max-w-[1200px] pt-3 sm:pt-[50px] flex flex-col sm:flex-row gap-6 sm:gap-0 items-start">
        <div className="w-full sm:w-1/2 pr-0 sm:pr-[80px]">
          <h4 className="text-[18px] sm:text-[24px] leading-[24px] sm:leading-[32px] font-poppins-regular">
            Our 360 Video Booth offers next-level experience transporting guests
            to a virtual world for dynamic videos. Bring your event to the
            next-level.
          </h4>
          <button className="mt-8 uppercase font-poppins-regular text-[#fff] text-[14px] sm:text-[16px] bg-[#000] px-[14px] sm:px-[32px] py-[8px] sm:py-[16px] rounded-[40px] ">
            DISCOVER 360 VIDEO BOOTH
          </button>
        </div>
        <div className="w-full sm:w-1/2">
          <Collapse
            bordered={false}
            expandIcon={({ isActive }) => ( <> { isActive ? <MinusOutlined /> : <PlusOutlined /> } </>)}
            expandIconPosition="end"
            items={ExperienceColData}
          />
        </div>
      </div>
    </section>
  );
};

export default Experience;


